import { createReducer } from "reduxsauce";

import ReducerRegister from "../ReducerRegister";
import SchoolService from "../../services/screens/SchoolService";
import { ActionTypes } from "../actionTypes/screens/SchoolSelectionActionTypes";
import AsyncActionReducers from "../AsyncActionReducers";

import UIDs from "../../UIDs";

const uid = UIDs.screens.schoolSelection;

//
// Actions
//
const Actions = {
    loadSchoolsAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCHOOLS_ASYNC });

            SchoolService.loadScreenView(
                (data) => {
                    dispatch(Actions.loadSchoolsSuccess(data));
                },
                (error) => {
                    dispatch(Actions.loadSchoolsFailure(error));
                }
            );
        };
    },

    loadSchoolsSuccess: (data) => ({
        type: ActionTypes.LOAD_SCHOOLS_SUCCESS,
        parentType: ActionTypes.LOAD_SCHOOLS_ASYNC,
        postReducer: loadSchoolsSuccessPostReducer,
        data,
    }),

    loadSchoolsFailure: (error) => ({
        type: ActionTypes.LOAD_SCHOOLS_FAILURE,
        parentType: ActionTypes.LOAD_SCHOOLS_ASYNC,
        error,
    }),

    searchSchools: (searchTerm) => ({
        type: ActionTypes.SEARCH_SCHOOLS,
        searchTerm,
    }),

    selectSchool: (school) => ({
        type: ActionTypes.SELECT_SCHOOL,
        school,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    schools: [],
    filteredSchools: [],
    searchTerm: "",
    loading: false,
    error: null,
    selectedSchool: null,
};

//
// Reducers
//

// Custom reducers for non-async actions
const searchSchoolsReducer = (state, { searchTerm }) => {
    const filteredSchools = searchTerm.trim() === "" ? state.schools : state.schools.filter((school) => school.name.toLowerCase().includes(searchTerm.toLowerCase()));

    return {
        ...state,
        searchTerm,
        filteredSchools,
    };
};

const selectSchoolReducer = (state, { school }) => ({
    ...state,
    selectedSchool: school,
});

const loadSchoolsSuccessPostReducer = (state, { data }) => {
    return { ...state, schools: data.viewModel.schools, filteredSchools: data.viewModel.schools };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCHOOLS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCHOOLS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCHOOLS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEARCH_SCHOOLS]: searchSchoolsReducer,
    [ActionTypes.SELECT_SCHOOL]: selectSchoolReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
